import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AiOutlineZoomIn } from 'react-icons/ai';
import backlinkApi from '../api/backlinkNewApi';

/**
 * Ag-grid cell: zoom icon → all backlinks with an FBy* filter in the query string.
 * Aggregate counts represent individual backlinks, so the drilldown must not
 * fall back to the page's default domain grouping.
 */
const DrilldownToReferralPageCell = ({
  displayValue,
  filterKey,
  filterMode,
  filterValue
}: Record<string, any>) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { domain_slug, domain } = useParams();

  const encodedFilter =
    filterMode === 'blank'
      ? `%5Band%2Cblank%2Cnull%5D`
      : `%5Band%2C${filterMode}%2C${encodeURIComponent(filterValue ?? '')}%5D`;

  const handleClick = () => {
    dispatch(backlinkApi.util.invalidateTags(['BACKLINKS']));
    const domainSegment =
      domain_slug && domain ? `/${domain_slug}/${domain}` : '';
    navigate(
      `/backlink/backlinks${domainSegment}?FBy${filterKey}=${encodedFilter}&grouping=all`
    );
  };

  return (
    <div>
      <AiOutlineZoomIn
        onClick={handleClick}
        className="mx-2 cursor-pointer fs-0"
      />
      <span>{displayValue}</span>
    </div>
  );
};

export default DrilldownToReferralPageCell;
